import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../app.constants';
import { OidcSecurityService } from '../auth/services/oidc.security.service';
import { NoteSearchModel } from '../shared/models/note-related/NoteSearchModel';
import { NoteUpdateModel } from '../shared/models/note-related/NoteUpdateModel';
import { NoteCreateModel } from '../shared/models/note-related/NoteCreateModel';

@Injectable()
export class NoteService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/NoteWidget/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (entityId: string): Observable<NoteSearchModel[]> => {
        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + entityId, options).map(res => res.json());
    }

    public GetOne = (noteId: string): Observable<NoteSearchModel> => {
        this.setHeaders();
        let params = new URLSearchParams();
        params.set('noteId', noteId);
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public Update = (noteToUpdate: NoteUpdateModel): Observable<Response> => {
        this.setHeaders();
        noteToUpdate.UserId = this.uData.sub;
        return this._http
            .put(this.actionUrl, JSON.stringify(noteToUpdate), { headers: this.headers });
    }

    public Create = (newNote: NoteCreateModel): Observable<Response> => {
        this.setHeaders();
        newNote.UserId = this.uData.sub;
        return this._http
            .post(this.actionUrl, JSON.stringify(newNote), { headers: this.headers });
    }

    public Delete = (): Observable<Response> => {
        this.setHeaders();
        return this._http
            .post(this.actionUrl, { headers: this.headers });
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/services/note-service.ts